module.exports = __webpack_public_path__ + "img/blue-booth-table-4.e52f9feb.png";